module.exports = __webpack_public_path__ + "static/media/verifiedb.50f0da24.svg";